module.exports = __webpack_public_path__ + "img/big_brain_holding.db7534da.png";